import { LocationEngineInfo } from './engine-info';
import { LocationSearchRequest } from './search-request';
import { SearchResult } from './search-result';

export const LocationSearchService = Symbol('LocationSearchService');
export interface LocationSearchService<R extends SearchResult> {
  getEngineSpecification(): LocationEngineInfo;
  doLocationSearch(search: LocationSearchRequest): Promise<R[]>;
}
